/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

/**
 * one letter(uppercase or lowercase)
 * and one special character(!, #, $, %, &, *, @, ^)
 */
export const alnumRequirement = /^(?=.*\d)(?=.*[A-Za-z])(?=.*[!#$%&*@^])/;

/**
 * does match: aaa_bbb, abAb12, 12345, Abcde0123
 * not match: 어댑터, Adapter-1234, (adapter)
 */
export const adapterRouteRegex = /^[a-zA-Z0-9_]+$/;
